import type React from 'react'
import type { ControllerFieldState } from 'react-hook-form'

import { Info } from '@/components/icons/Info'
import { FormLabel } from '@/components/ui/form'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/styles'

type Props = {
	readonly label?: React.ReactNode
	readonly fieldState?: ControllerFieldState
	readonly required?: boolean
	readonly className?: string
	readonly tooltipContent?: React.ReactNode
}

export function AppFormLabel({ label, required, className, tooltipContent }: Props) {
	if (label == null) {
		return null
	}

	return (
		<FormLabel className={cn('flex gap-1 mb-2 font-bold', className)}>
			{label}
			{required && (
				<TooltipProvider>
					<Tooltip>
						<TooltipTrigger>
							<span className="text-neutral-light-600">
								<Info />
							</span>
						</TooltipTrigger>
						<TooltipContent>
							{/* TODO add styles to tooltip when provided */}
							<p>{tooltipContent}</p>
						</TooltipContent>
					</Tooltip>
				</TooltipProvider>
			)}
		</FormLabel>
	)
}
